import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode } from "react";

interface SidePanelContentProps {
  /** The content to display in the side panel */
  children: ReactNode;
  
  /** Whether the side panel is opened or not */
  isOpened?: boolean;
  
  /** The width of the side panel content in pixels */
  contentWidth?: string;
  
  /** Additional styling to apply to the side panel container */
  sx?: SxProps<Theme>;
}

/**
 * SidePanelContent component handles the animation and visibility of content
 * within a side panel.
 */
export function SidePanelContent({
  children,
  isOpened = false,
  contentWidth = "320",
  sx = {},
}: SidePanelContentProps): JSX.Element {
  return (
    <Box
      sx={{
        overflow: "hidden",
        opacity: isOpened ? 1 : 0,
        visibility: isOpened ? "visible" : "hidden",
        width: isOpened ? `${contentWidth}px` : "0",
        transition: "0.3s ease-in-out",
        height: "100%",
        ...sx,
      }}
      data-testid="side-panel-content"
    >
      {children}
    </Box>
  );
}